let baseurl;

if (process.env.NODE_ENV === "development")
  baseurl = "http://localhost:5000"
else
  baseurl = "https://api.yaminimaddalamd.com"

export default baseurl;